import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import Auth from "../../auth/Auth";
import { IStore } from "../../models/IStore";

export interface ICallbackSamlQaAuProps extends RouteComponentProps {
  auth: Auth;
}

export class CallbackSamlQaAu extends React.Component<
  ICallbackSamlQaAuProps
> {
  public constructor(props: ICallbackSamlQaAuProps) {
    super(props);
  }

  public componentDidMount() {
    const { auth } = this.props;

    auth.loginSAMLQaAu().then(() => {
      console.log("Login via SAML QA Australia");
    });
  }

  public render() {
    return <div>Loading...</div>;
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    auth: state.auth0
  };
};

export default connect(mapStateToProps)(CallbackSamlQaAu);
